export { default } from './DateSeparator';
